import { Button } from "@loot-os/ui/components/button";

import type { BoxStatus } from "../lib/boxEditor";

/**
 * Draft / active, for either editor. Activating needs a published version — the server
 * enforces it, so the button simply isn't offered. An archived box offers its way back to
 * draft; archiving itself is in the ⋯ menu beside Delete.
 */
export function BoxStatusActions({
  status,
  currentVersion,
  onSetStatus,
  pending,
}: {
  status: BoxStatus;
  currentVersion: number;
  onSetStatus: (status: BoxStatus) => void;
  pending: boolean;
}) {
  if (status === "archived") {
    return (
      <Button
        type="button"
        variant="outline"
        onClick={() => onSetStatus("draft")}
        disabled={pending}
      >
        Restore to draft
      </Button>
    );
  }
  if (status === "active") {
    return (
      <Button
        type="button"
        variant="outline"
        onClick={() => onSetStatus("draft")}
        disabled={pending}
      >
        Set draft
      </Button>
    );
  }
  return currentVersion > 0 ? (
    <Button
      type="button"
      variant="outline"
      onClick={() => onSetStatus("active")}
      disabled={pending}
    >
      Activate
    </Button>
  ) : null;
}
